import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BasicWithLibelleModel } from 'src/app/shared/models/basic/basicWithLibelle.model';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import * as util from '../../../constants/util';

@Component({
  selector: 'app-autocomplete-societe',
  templateUrl: './autocomplete-societe.component.html',
  styleUrls: ['./autocomplete-societe.component.scss']
})
export class AutocompleteSocieteComponent implements OnChanges {


  @Input() objets: BasicWithLibelleModel[];
  @Input() objet: BasicWithLibelleModel;
  @Input() parent: UntypedFormGroup;
  @Input() name: string;
  @Input() libelle: string;
  @Output() objetChange = new EventEmitter<BasicWithLibelleModel>();

  filteredObjets: Observable<string[]>;
  objetsString: string[];
  myControl: AbstractControl;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.myControl = this.parent.get('societe');
    const validators = [];
    validators.push(forbiddenNamesValidator(this.objets));
    if (util.hasRequiredField(this.myControl)) {
      validators.push(Validators.required);
    }
    if (this.objets) {
      this.reLoadObjets();
      if (this.objet && this.objets.length) {
        const objet = this.objets.find(obj => obj.code === this.objet.code);
        if (objet) {
          this.myControl.setValue(objet.code + '-' + objet.libelle);
        }
      }
    }
    this.myControl.setValidators(validators);

  }

  reLoadObjets(): void {
    this.objetsString = [];
    if (this.objets !== undefined) {
      for (const objet of this.objets) {
        this.objetsString.push(objet.code + '-' + objet.libelle);
      }
      this.objetsString.sort((a, b) => a.localeCompare(b));
      this.filteredObjets = this.myControl.valueChanges.pipe(
        startWith(null),
        map((obj: string | null) => obj ? this._filter(obj) : this.objetsString.slice(0, 30)));
    }
  }

  private _filter(value: string): string[] {
    const filterValue = ('' + value).toLowerCase();
    const objSelected = this.objetsString.find(obj => obj.toLowerCase() === filterValue);
    if (objSelected){
      return this.objetsString.slice(0, 30);
    } else {
      return this.objetsString.filter(obj => obj.toLowerCase().indexOf(filterValue) >= 0).slice(0, 30);
    }
  }

  deleteIfEmpty(): void {
    this.objetChange.emit(null);
  }

  onObjetChange(event: MatAutocompleteSelectedEvent): void {
    const value = event.option.viewValue;
    const objet = this.objets.find(obj => obj.code + '-' + obj.libelle === value);
    if (objet) {
      this.objetChange.emit(objet);
    }
  }

}
export function forbiddenNamesValidator(names: BasicWithLibelleModel[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    // below findIndex will check if control.value is equal to one of our options or not
    if (control.value && names) {
      const index = names.findIndex(name => {
        return (name.code + '-' + name.libelle).localeCompare(control.value) === 0;
      });
      return index < 0 ? { 'forbiddenNames': { value: control.value } } : null;
    } else {
      return null;
    }
  };
}
